import React from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { Sidebar } from './Sidebar';
import { BackToTopButton } from './BackToTopButton';
import { useSearch } from '../contexts/SearchContext';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { searchQuery, setSearchQuery } = useSearch();
  const location = useLocation();





  // Check if we're on the home page (including all language variants)
  const isHomePage = location.pathname === '/' ||
                     location.pathname.match(/^\/[a-z]{2}$/) ||
                     location.pathname.match(/^\/[a-z]{2}-[A-Z]{2}$/) ||
                     location.pathname.match(/^\/[a-z]{2}\/$/) ||
                     location.pathname.match(/^\/[a-z]{2}-[A-Z]{2}\/$/);



  return (
    <div className="min-h-screen flex">
      {/* Left Sidebar - Fixed */}
      <div className="hidden lg:flex lg:flex-col lg:w-72 lg:fixed lg:inset-y-0 lg:z-50">
        <Sidebar />
      </div>

      {/* Right Content Area */}
      <div className="flex-1 lg:ml-72 flex flex-col min-h-screen">
        {/* Header */}
        <Header
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          showSearch={isHomePage}
        />

        {/* Main Content */}
        <main className="flex-1 overflow-auto">
          {children}
        </main>

        {/* Footer */}
        <Footer />
      </div>

      {/* Back to Top Button */}
      <BackToTopButton />
    </div>
  );
};
